import AppStore from './App';
import AuthStore from './Auth';
import BundleStore from './Bundle';
import CourseStore from './Course';
import DashboardStore from './Dashboard';
import DiscountStore from './Discount';
import GroupStore from './Group';
import InvitationStore from './Invitation';
import InviteStore from './Invite';
import InviteWizardStore from './InviteWizard';
import MediaLibraryStore from './MediaLibrary';
import MediaLibraryOverviewStore from './MediaLibraryOverview';
import MessageStore from './Message';
import NotificationStore from './Notification';
import SettingsStore from './Settings';
import StoreStore from './Store';
import StudentStore from './Student';
import TransactionStore from './Transaction';
import ThemeStore from './Theme';
import TaskStore from './Task';
import UserStore from './User';
import ExportStore from './Export';
import ClipboardStore from './Clipboard';
import KlarnaStore from './Klarna';
import StudentOverviewStore from './StudentOverview';
import PageLayoutStore from './PageLayout';
import StoreOverviewStore from './StoreOverview';
import PaymentStore from './Payment';
import CategoryStore from './Category';
import StripeStore from './Stripe';
import QuizStore from './Quiz';
import QuizDetailStore from './QuizDetail';
import WebinarStore from './Webinar';
import PageStore from './Page';

export {
  AppStore,
  AuthStore,
  BundleStore,
  CourseStore,
  DashboardStore,
  DiscountStore,
  GroupStore,
  InvitationStore,
  InviteStore,
  InviteWizardStore,
  MediaLibraryStore,
  MediaLibraryOverviewStore,
  MessageStore,
  NotificationStore,
  SettingsStore,
  StoreStore,
  StudentStore,
  TransactionStore,
  ThemeStore,
  TaskStore,
  UserStore,
  ExportStore,
  ClipboardStore,
  KlarnaStore,
  StudentOverviewStore,
  PageLayoutStore,
  StoreOverviewStore,
  PaymentStore,
  CategoryStore,
  StripeStore,
  QuizStore,
  QuizDetailStore,
  WebinarStore,
  PageStore,
};

export default {
  AppStore,
  AuthStore,
  BundleStore,
  CourseStore,
  DashboardStore,
  DiscountStore,
  GroupStore,
  InvitationStore,
  InviteStore,
  InviteWizardStore,
  MediaLibraryStore,
  MediaLibraryOverviewStore,
  MessageStore,
  NotificationStore,
  SettingsStore,
  StoreStore,
  StudentStore,
  TransactionStore,
  ThemeStore,
  TaskStore,
  UserStore,
  ExportStore,
  ClipboardStore,
  KlarnaStore,
  StudentOverviewStore,
  PageLayoutStore,
  StoreOverviewStore,
  PaymentStore,
  CategoryStore,
  StripeStore,
  QuizStore,
  QuizDetailStore,
  WebinarStore,
  PageStore,
};



// WEBPACK FOOTER //
// ./src/js/stores/index.js